import { docReady } from '../helpers/docReady';
import '../../styles/templates/blog.scss';
docReady(() => {
    console.log('Cardigang: Blog JS Loaded');
});
